import { useTrackingQuery } from '..';
export var useTroquefacilRedirectLink = function useTroquefacilRedirectLink() {
  var _useTrackingQuery$dat;

  return (_useTrackingQuery$dat = useTrackingQuery().data) === null || _useTrackingQuery$dat === void 0 ? void 0 : _useTrackingQuery$dat.troqueFacilRedirectLink;
};